<template>
  <section v-if="selector">
    <transition
      name="fade"
      mode="out-in"
    >
      <div
        :class="{
          'l-selector--single-section-no-illustration':
            !showIllustration && selector.singleSection,
          'l-selector--single-section-illustration':
            showIllustration && selector.singleSection,
          'l-selector--multi-section-no-illustration':
            !showIllustration && !selector.singleSection,
          'l-selector--multi-section-illustration':
            showIllustration && !selector.singleSection,
          'l-selector--illustration': showIllustration,
        }"
        class="l-selector"
      >
        <section-navigation
          v-if="selector && selector.singleSection === false"
          class="l-selector__sections"
        />
        <ResidenceIllustration
          v-if="showIllustration"
          class="l-selector__illustration"
        />
        <ResidenceNavigation class="l-selector__filter" />
        <ResidenceList
          class="l-selector__list"
          :class="{
            'l-selector__list--full': !showIllustration,
          }"
        />
      </div>
    </transition>
  </section>
</template>

<script>
// Data models
import Residence from '@/models/Residence';
import Selector from '@/models/Selector';

// UI components
import SectionNavigation from '@/components/SectionNavigation.vue';
import ResidenceList from '@/components/ResidenceList.vue';
import ResidenceIllustration from '@/components/ResidenceIllustration.vue';
import ResidenceNavigation from '@/components/ResidenceNavigation.vue';

export default {
  name: 'Home',
  components: {
    SectionNavigation,
    ResidenceList,
    ResidenceIllustration,
    ResidenceNavigation,
  },
  computed: {
    selector() {
      return Selector.query().with('sections').first();
    },
    showIllustration() {
      if (
        this.selector.showIllustration === false ||
        this.selector.overview_illustration_ids[0] === false
      ) {
        return false;
      }
      return true;
    },
    viewType() {
      return this.$store.state.entities.selectors.viewType;
    },
    loadStatus() {
      return this.$store.state.entities.residences.loadStatus;
    },
    hasThumbnails() {
      return this.$store.state.entities.residences.hasThumbnails;
    },
    projectId() {
      return this.$store.state.entities.selectors.projectId;
    },
  },
  mounted() {
    this.getResidenceImages();
    this.track();
    this.scrollResidenceIntoView();
    if (localStorage.viewType) {
      this.updateViewType(localStorage.viewType);
    }
  },
  methods: {
    getResidenceImages() {
      const viewType = this.selector.listType;
      const hasThumbnails = this.$store.state.entities.residences.hasThumbnails;
      const hasImages = this.$store.state.entities.residences.hasImages;
      if (viewType === 'cards' && hasThumbnails === false) {
        const sourceData = window.__selector_settings__.sourceData;
        Residence.fetchAllWithImages(
          this.projectId,
          sourceData.sourceURL,
          sourceData.hiddenId,
          hasImages
        );
        Residence.commit(state => {
          state.hasThumbnails = true;
        });
      }
    },
    // Helper function to check if an element is in view
    isInViewport(element) {
      const rect = element.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <=
          (window.innerWidth || document.documentElement.clientWidth)
      );
    },
    scrollResidenceIntoView() {
      const viewed = this.$store.state.entities.residences.viewed;

      // Check if there is anything stored in viewedLast from viewing a residence.
      if (viewed !== '') {
        // Find the corresponding residence element
        const residence = document.getElementById(viewed);

        // Check if residence exist in DOM (Could be hidden by a flter)
        if (residence) {
          // Check if the user is seing two columns or one
          if (window.innerWidth > 960) {
            // Get scrollHelper element and scroll window to that if it isn't in view
            const scrollHelper = document.getElementById('scrollHelper');
            if (this.isInViewport(scrollHelper) === false) {
              scrollHelper.scrollIntoView({
                block: 'start',
                behavior: 'smooth',
              });
            }

            // Get residencelist and scroll that to the current residence
            const residenceList = document.getElementById('residenceList');
            const offset = residence.offsetTop;
            residenceList.scrollTo({
              top: offset,
              behavior: 'smooth',
            });
          } else {
            // The user is on one column
            // Scroll the window to the corresponding residence element.
            residence.scrollIntoView({
              block: 'center',
              behavior: 'smooth',
            });
          }
        }

        // Reset viewedLast
        Residence.commit(state => {
          state.viewed = '';
        });
      }
    },
    track() {
      // Check if there is a Google Analytics toggle on.
      if (window.__selector_settings__.trackers.gaCheck === true) {
        // Send data to Google Analytics
        this.$gtag.pageview({
          page_path: '/boligprosjekter/',
          page_title: 'Boliger – oversikt',
        });
      }
    },
    updateViewType(viewType) {
      Selector.commit(state => {
        state.viewType = viewType;
      });
    },
    setViewType(viewType) {
      this.updateViewType(viewType);
      localStorage.setItem('viewType', viewType);
    },
  },
};
</script>
